var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('questions', _vm._b({
    on: {
      "input": _vm.storeQuestions
    },
    model: {
      value: _vm.questions,
      callback: function callback($$v) {
        _vm.questions = $$v;
      },
      expression: "questions"
    }
  }, 'questions', _vm.value, false)), _c('div', {
    staticClass: "v-btn-group flex-wrap"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('prev');
      }
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("이전으로")])]), _c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function click($event) {
        return _vm.save();
      }
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("임시저장")])]), _c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.save(_vm.COMPLETED.value);
      }
    }
  }, [_c('span', [_vm._v("저장 후 다음으로")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }